<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Process the purchase</div>
            <fieldset class="border p-2">
              <div>
                <form @submit.prevent="newPurchase()">
                  <input
                    type="hidden"
                    class="goodsreceving_id"
                    :value="Goodreceiving.id"
                  />
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">Product</th>
                          <th scope="col text-right">Unit</th>
                          <th scope="col">Quantity</th>
                          <th scope="col text-right">Unit price</th>
                          <th scope="col text-right">Remark</th>
                          <th scope="col text-right">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(invoice_product, k) in systemPurchasegrn"
                          :key="k"
                        >
                          <td>
                            <select
                              class="form-control product_id"
                              v-model="invoice_product.product_id"
                              readonly
                              disabled
                            >
                              <option value>Select product</option>
                              <option
                                v-for="product in systemProducts"
                                :value="product.id"
                                :key="product.id"
                              >
                                {{ product.product_name }}
                              </option>
                            </select>
                          </td>
                          <td>
                            <select
                              name="product_measurement"
                              class="form-control input_rounded product_measurement"
                              v-model="invoice_product.product_measurement"
                              readonly
                              disabled
                            >
                              <option value>Select Measurement</option>
                              <option value="KG">KILOGRAMS</option>
                              <option value="PCS">PIECES</option>
                              <option value="LTS">LITRES</option>
                              <option value="SET">SET</option>
                              <option value="PAIR">PAIR</option>
                              <option value="MTR">METRES</option>
                            </select>
                          </td>
                          <td>
                            <input
                              class="form-control"
                              type="number"
                              min="0"
                              step=".01"
                              v-model="invoice_product.qty"
                              readonly
                              @change="calculateLineTotal(invoice_product)"
                            />
                          </td>
                          <td>
                            <input
                              class="form-control"
                              type="number"
                              min="0"
                              step=".01"
                              v-model="invoice_product.unit_price"
                              readonly
                              @change="calculateLineTotal(invoice_product)"
                            />
                          </td>
                          <td>
                            <input
                              class="form-control"
                              type="text"
                              v-model="invoice_product.remarks"
                              readonly
                            />
                          </td>
                          <td>
                            <input
                              readonly
                              class="form-control text-right"
                              type="number"
                              min="0"
                              step=".01"
                              v-model="invoice_product.total_price"
                            />
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="5" class="text-right">Total</td>
                          <input
                            readonly
                            class="form-control text-right purchase_total"
                            type="number"
                            min="0"
                            step=".01"
                            :value="Total.toFixed(2)"
                          />
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary btn-flat creatingPurchase btn-rounded"
                  >
                    <i class="fa fa-plus"></i> process pay
                  </button>
                  <button
                    type="button"
                    class="btn-rounded btn-flat creatingPurchaseLoader btn-rounded"
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <i
                      class="fa fa-spinner fa-spin"
                      style="font-size: 24px"
                    ></i>
                    please wait...
                  </button>
                </form>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import $ from "jquery";
import router from "../router/index";
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0,
    };
  },
  created() {
    if (this.$store.getters.Goodreceiving.length === 0) {
      router.push("/managegoodsreceiving");
    }
    this.loadProduct();
  },
  computed: {
    ...mapGetters([
      "systemPurchasegrn",
      "purchaseitemsRows",
      "systemProducts",
      "Goodreceiving",
    ]),
    Total() {
      return this.systemPurchasegrn.reduce(
        (acc, item) => acc + item.unit_price * item.qty,
        0
      );
    },
  },
  methods: {
    ...mapActions(["loadProduct", "newPurchase"]),
    ...mapMutations(["addPurchaseorderItems"]),

    calculateLineTotal(invoice_product) {
      var total =
        parseFloat(invoice_product.unit_price) *
        parseFloat(invoice_product.qty);
      if (!isNaN(total)) {
        invoice_product.total_price = total.toFixed(2);
      }
      this.Total;
    },
  },
};
</script>
<style scoped>
.creatingPurchaseLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/purchases/purchase.vue